import { useEffect } from 'react';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import store from '@store';
import AppRouter from './router';
import GlobalErrorListener from '@components/common/GlobalErrorListener';
import ErrorBoundary from '@components/common/ErrorBoundary';
import '@styles/global.css';
import '@styles/bootstrap-overrides.css';
import '@styles/dashboardTour.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  // Initialize analytics on app load
  useEffect(() => {
    // analytics.init();
  }, []);

  // Initialize theme on app load

  return (
    <ErrorBoundary>
      <Provider store={store}>
        <>
          <GlobalErrorListener />
          <AppRouter />
          <ToastContainer />
        </>
      </Provider>
    </ErrorBoundary>
  );
}

export default App;
